import { gql } from '@apollo/client'

export const MODIFY_POLICIES_QUERY = gql`
  query ModifyPolicies($providerCode: String!) {
    modifyPolicies(providerCode: $providerCode) {
      basicDetails {
        name
        description
        descriptionTranslatedList {
          label
          value
          nativeLabel
        }
        id
      }
      table {
        applied
        priority
        penaltyAmount
        deadline
        deadlineTimeOffset
        penaltyType
        policyType
      }
    }
  }
`
export const MODIFY_POLICY_QUERY = gql`
  query ModifyPolicy($providerCode: String!, $policyID: String!) {
    modifyPolicy(providerCode: $providerCode, policyID: $policyID) {
      basicDetails {
        name
        description
        descriptionTranslatedList {
          label
          value
          nativeLabel
        }
        id
      }
      table {
        applied
        priority
        penaltyAmount
        deadline
        deadlineTimeOffset
        penaltyType
        policyType
      }
    }
  }
`

export const MODIFY_POLICY_GENERATE = gql`
  mutation GenerateModifyPolicy(
    $input: CancelPolicyInput!
    $providerCode: String!
  ) {
    generateModifyPolicy(input: $input, providerCode: $providerCode) {
      message
    }
  }
`
export const MODIFY_POLICY_MODIFY = gql`
  mutation ModifyModifyPolicy(
    $input: CancelPolicyInput!
    $providerCode: String!
  ) {
    modifyModifyPolicy(input: $input, providerCode: $providerCode) {
      message
    }
  }
`
